<!-- <app-layout> -->
<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2 mb-3">
  Clienti
  <!-- <mat-icon
    aria-hidden="false"
    aria-label="Example home icon"
    fontIcon="dataset"
  ></mat-icon> -->
</h3>

<!-- <mat-card class="mb-2 search-card"> -->
  <div class="ms-0 me-0 mb-0">
    <div class="search-container d-flex align-items-stretch h-100 mb-0">
      <mat-form-field
        appearance="outline"
        class="search-field flex-grow-1 mb-0"
      >
        <mat-label>Cerca clienti</mat-label>
        <input
          matInput
          placeholder="Cerca nomi, indirizzi..."
          (keyup)="applyFilter($event)"
        />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>
<!-- </mat-card> -->

<div class="mt-0 mb-3 d-flex justify-content-between align-items-center">
  <!-- chips -->
  <mat-chip-set aria-label="Filter selection" class="flex-grow-1">
    <mat-chip-option 
      *ngFor="let option of filterOptions" 
      [value]="option.value"
      [selected]="selectedFilter === option.value"
      (click)="applyTypeFilter(option.value)">
      {{option.name}}
    </mat-chip-option>
  </mat-chip-set>

  <button
    mat-raised-button
    color="primary"
    (click)="navigateToNewCompany()"
    class="ms-3 primary-button"
    matButton="filled"
  >
    <mat-icon>add</mat-icon>
    <span>Aggiungi</span>
  </button>
</div>

<mat-card class="mb-3 mb-md-0 col-md-12 d-flex flex-column custom-card hidden-mobile">
  <mat-card-content>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
      <p class="mt-3">Caricando clienti...</p>
    </div>

    <!-- Show empty state when no data -->
    <div *ngIf="companySource.filteredData.length === 0 && !isLoading" class="empty-state text-center py-5">
      <img 
        src="izy_image_2.png" 
        alt="Nessun cliente"
        class="empty-state-image mb-3"
        style="max-width: 300px; opacity: 1;"
      >
      <h4 class="text-muted">Nessun cliente registrato</h4>
      <p class="text-muted">Inizia aggiungendo il tuo primo cliente!</p>
    </div>

    <table
    *ngIf="companySource.filteredData.length > 0"
      mat-table
      [dataSource]="companySource"
      class="mat-elevation-z8 hidden-mobile"
    >
      <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Azioni</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon matButton [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">more_vert</mat-icon>
            <mat-menu #menu="matMenu" xPosition="before">
              <button mat-menu-item (click)="onRowClick(element)">
                <mat-icon>manage_search</mat-icon>
                <span>Vedi dettagli</span>
              </button>
              <button mat-menu-item (click)="openCompanyInvoicesBottomSheet(element)">
                <mat-icon>payments</mat-icon>
                <span>Vedi fatture</span>
              </button>
              <button mat-menu-item (click)="navigateToNewInvoice(element)">
                <mat-icon>add_card</mat-icon>
                <span>Nuova fattura</span>
              </button>
              <button mat-menu-item (click)="deleteCompany(element)" class="text-danger">
                <mat-icon color="warn">delete</mat-icon>
                <span>Elimina cliente</span>
              </button>
            </mat-menu>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="company_name">
        <th mat-header-cell *matHeaderCellDef>Nome Cliente</th>
        <td mat-cell *matCellDef="let element">{{element.company_name}}</td>
      </ng-container>

      <ng-container matColumnDef="iva_number">
        <th mat-header-cell *matHeaderCellDef>P. IVA</th>
        <td mat-cell *matCellDef="let element">{{element.iva_number}}</td>
      </ng-container>

      <ng-container matColumnDef="email_address">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let element">{{element.email_address}}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let element">
          <mat-chip class="centered-chip">
          <p class="text-small">{{element.type}}</p>
          </mat-chip>
        </td>
      </ng-container>

      <ng-container matColumnDef="cellphone">
        <th mat-header-cell *matHeaderCellDef>Cellulare</th>
        <td mat-cell *matCellDef="let element">{{element.cellphone}}</td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef>Indirizzo</th>
        <td mat-cell *matCellDef="let element">{{element.address}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        (click)="onRowClick(row)"
      ></tr>
    </table>

    <!-- <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      showFirstLastButtons
      aria-label="Select page of companies"
    ></mat-paginator> -->
    <!-- Add the paginator at the bottom of the table -->
    <mat-paginator
      [pageSizeOptions]="[10, 20, 50, 100]"
      [pageSize]="20"
      showFirstLastButtons
      aria-label="Select page of companies"
      class="hidden-mobile"
    >
    </mat-paginator>

    <mat-divider class="visible-mobile"></mat-divider>
  </mat-card-content>
</mat-card>

<!-- Mobile Cards -->
<div class="mobile-cards visible-mobile">

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-3">Caricando clienti...</p>
  </div>
  <!-- Empty state for mobile -->
  <div *ngIf="companySource.filteredData.length === 0 && !isLoading" class="empty-state text-center py-5">
    <img 
      src="izy_image_2.png" 
      alt="Nessun cliente"
      class="empty-state-image mb-3"
      style="max-width: 250px; opacity: 1;"
    >
    <h4 class="text-muted">Nessun cliente registrato</h4>
    <p class="text-muted">Inizia aggiungendo il tuo primo cliente!</p>
  </div>

  <mat-card
    *ngFor="let item of companySource.filteredData"
  >
    <mat-card-content>
      <div class="d-flex m-0 justify-content-between align-items-center">
      <h6><strong>{{item.company_name}}</strong></h6>
        <mat-icon matButton [matMenuTriggerFor]="menu">more_vert</mat-icon>
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item (click)="onRowClick(item)">
              <mat-icon>manage_search</mat-icon>
              <span>Vedi dettagli</span>
            </button>
            <button mat-menu-item (click)="openCompanyInvoicesBottomSheet(item)">
              <mat-icon>payments</mat-icon>
              <span>Vedi fatture</span>
            </button>
            <button mat-menu-item (click)="navigateToNewInvoice(item)">
              <mat-icon>add_card</mat-icon>
              <span>Nuova fattura</span>
            </button>
            <!-- <button mat-menu-item disabled>
              <mat-icon>voicemail</mat-icon>
              <span>Check voice mail</span>
            </button> -->
            <button mat-menu-item (click)="deleteCompany(item)" class="text-danger">
              <mat-icon color="warn">delete</mat-icon>
              <span>Elimina cliente</span>
            </button>
          </mat-menu>
        </div>

      <p class="mb-1 text-small"><strong>P. IVA:</strong> {{item.iva_number}}</p>
      <p class="mb-1 text-small"><strong>Email:</strong> {{item.email_address}}</p>
      <!-- <p class="mb-1"><strong>Phone:</strong> {{item.cellphone}}</p> -->
      <div class="d-flex mt-0 mb-0 justify-content-between align-items-center white-bg">
        <mat-chip 
            selected>
          {{item.type}}
        </mat-chip>

        <button mat-stroked-button (click)="onRowClick(item)" class="me-2">
          <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0">Apri</p>
          <span>
            <mat-icon class="ms-2 mt-1 m-0">chevron_right</mat-icon>
          </span>
          </div>
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- <mat-paginator
    *ngIf="companySource.filteredData.length > 0"
    [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="10"
    showFirstLastButtons
  >
  </mat-paginator> -->
</div>

<div class="pt-3 mb-3"></div>

<!-- <div class="form-container">
  <h2>Add New Company</h2>

    <button
      mat-raised-button
      color="primary"
      (click)="navigateToNewCompany()"
    >
      Add Company
    </button>
</div> -->
<!-- </app-layout> -->
